import React from 'react';

/**
 * In-page loading placeholder: a title, a toolbar strip and a table card,
 * drawn INSIDE the content card. Pages use this while their data loads;
 * LoadingScreen is the full-window boot skeleton (it paints its own sidebar
 * over the real one) and belongs only to the auth/boot gates.
 */
const PageSkeleton = ({ message = 'Loading', rows = 8 }) => (
  <div className="rn-route-fallback" role="status" aria-busy="true" aria-label={message}>
    <div className="lodge-skeleton" style={{ height: 28, width: '32%', borderRadius: 8 }} />
    <div className="lodge-skeleton" style={{ height: 36, width: '60%', borderRadius: 999 }} />
    <div className="lodge-skeleton" style={{ height: 44, borderRadius: 12 }} />
    {Array.from({ length: rows }, (_, i) => (
      <div key={i} className="lodge-skeleton" style={{ height: 18, width: `${92 - (i % 3) * 9}%`, borderRadius: 6 }} />
    ))}
  </div>
);

export default PageSkeleton;
